// extracted by mini-css-extract-plugin
export default {"logo":"T7","cancel":"U7","stickyheader":"V7","buttonswrap":"W7","item":"X7","starterKit":"Y7","boldHeader":"Z7","reviewheader":"a8","text":"b8","username":"c8"};
    if(module.hot) {
      // 1713809680189
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  